<template>
  <div class="row no-gutters">
    <div class="col-12 d-flex justify-content-center f-bold s-14 mb-3 align-items-center">
      <span>
        Fill in the writing area for signature
      </span>
    </div>
    <div class="col-12 d-flex justify-content-center">
      <div class="lsinput">
        <input type="text"
               maxlength="25"
               @input="signature = convertFormat($event.target.value)"
               @keyup="convertSign"
               :value="signature">
      </div>
    </div>
    <div class="col-12 d-none justify-content-center">
      <canvas id="canvas" :height="canvas.height" :width="canvas.width" class="d-none"></canvas>
      <div id="theHtml" class="text-signature">
        <span class="text-signature" style="font-family: 'Italianno', cursive; font-size: 54px; text-transform: capitalize;">
          {{signature}}
        </span>
      </div>
    </div>
    <div class="col-12 d-flex justify-content-center" v-if="image && signature">
      <img :src="image"/>
    </div>
  </div>
</template>

<script>
import * as rasterizeHTML from 'rasterizehtml';

export default {
  name: 'TextToSignature',
  data() {
    return {
      signature: null,
      image: false,
      canvas: {
        width: 500,
        height: 100,
      },
    };
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  methods: {
    convertSign() {
      const canvas = document.getElementById('canvas');
      const context = canvas.getContext('2d');
      const htmlContainer = document.getElementById('theHtml');
      const html = htmlContainer.innerHTML;

      rasterizeHTML.drawHTML(`<style>@import url('https://fonts.googleapis.com/css2?family=Italianno&family=Meddon&display=swap');</style>${html}`, canvas).then((renderResult) => {
        context.clearRect(0, 0, canvas.width, canvas.height);

        context.drawImage(renderResult.image, 0, 0);

        this.image = canvas.toDataURL();
      });

      if (!this.signature) {
        this.image = false;
      }
    },
    capitalize_Words(str) {
      return str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
    },
    save() {
      this.convertSign();
      if (!this.image) {
        this.warningMessage('You must fill signature area to save.');
      }
    },
    clear() {
      this.signature = null;
      this.image = false;
    },
    handleResize() {
      const windowsWidth = window.innerWidth;

      if (windowsWidth < 768) {
        this.canvas.width = 300;
        this.canvas.height = 150;
      } else {
        this.canvas.width = 500;
        this.canvas.height = 100;
      }
    },
    convertFormat(str) {
      return this.capitalize_Words(str.toLowerCase());
    },
  },
};
</script>

<style  scoped>
@import url('https://fonts.googleapis.com/css2?family=Italianno&family=Meddon&display=swap');
.text-signature  {
  font-family: 'Italianno', cursive;
  font-size: 54px !important;
  font-weight: 500 !important;
}
input {
  height: 35px;
}
</style>
